<template>
  <div class="index" id="anchor">
    <!-- <Seacher></Seacher> -->
    <div class="verify">
      <div class="verifylist">
        <div class="sucess_tit">Transformers Explorer</div>
        <div class="sucess_box">
          <img :src="imgname" />
          <div class="sucess_tits">successfully verified</div>
          <div class="sucess_con">
            Congratulations! Your contract<br />
            has been successfully<br />
            verified!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      imgname: require("@/assets/pc/TopValidators/TopValidators4.png"),
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {
    $route: {
      handler(val, oldval) {
        
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;

  .verify {
    width: 702px;
    margin: 0 auto;
    height: 995px;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .sucess_tit {
      height: 75px;
      font-size: 52px;
      font-family: Source Han Sans-Medium, Source Han Sans;
      font-weight: 500;
      color: #ffffff;
      line-height: 75px;
      margin-top: 30px;
    }
    .sucess_box {
      width: 614px;
      height: 376px;
      background: #0b0c0f;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin-top: 194px;
      margin-left: 44px;
      img {
        width: 98px;
        height: 98px;
        margin-top: 50px;
        margin-left: 30px;
      }
      .sucess_tits {
        height: 20px;
        font-size: 30px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #00e79a;
        line-height: 20px;
        text-align: center;
        margin-top: 49px;
      }
      .sucess_con {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 28px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}
</style>
